module.exports = __webpack_public_path__ + "img/model3_ug.4663a1be.png";